import { render } from "./Alarms.vue?vue&type=template&id=9775c3f8&ts=true"
import script from "./Alarms.vue?vue&type=script&lang=ts"
export * from "./Alarms.vue?vue&type=script&lang=ts"

import "./Alarms.vue?vue&type=style&index=0&id=9775c3f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__